import { gql } from '@apollo/client'

export const OPERATION_ACCOUNTS_METRICS_BY_GEOLOC = gql`
  query MonitoringSitesByGeoloc($longitude: Float!, $latitude: Float!) {
    accounts: monitoringSitesByGeoloc(longitude: $longitude, latitude: $latitude) {
      site {
        id
        name
        sf_id  
        location {
          latitude
          longitude
        }
        state
        account_parent {
          id
          sf_id
          name
        }
        address {
          city
          zipcode
          street_name
          street_number
        }
      }
      last_seen
      available_level
      counting {
        active_users
        line_ok
        line_unreachable
        accesspoint_ok
        accesspoint_unreachable
        switch_ok
        switch_unreachable
        chromecast_ok
        chromecast_unreachable
        tv_ok
        tv_unreachable
        esl_ok
        esl_unreachable
        firewall_ok
        firewall_unreachable
        wan_tx_bits
        wan_rx_bits
      }
    }
  }
`

export const OPERATION_ACCOUNTS_METRICS = gql`
  query GetAccountsMetrics($sf_ids: [String!]) {
    accounts: monitoringSites(sf_ids: $sf_ids) {
      site {
        id
        name
        sf_id  
        location {
          latitude
          longitude
        }
        state
        account_parent {
          id
          sf_id
          name
        }
        address {
          city
          zipcode
          street_name
          street_number
        }
      }
      last_seen
      available_level
      counting {
        active_users
        line_ok
        line_unreachable
        accesspoint_ok
        accesspoint_unreachable
        switch_ok
        switch_unreachable
        chromecast_ok
        chromecast_unreachable
        tv_ok
        tv_unreachable
        esl_ok
        esl_unreachable
        firewall_ok
        firewall_unreachable
        cctv_camera_ok
        cctv_camera_unreachable
        cctv_server_ok
        cctv_server_unreachable
        pcd_ok
        pcd_unreachable
        wan_tx_bits
        wan_rx_bits
      }
    }
  }
`